<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <slot name="header">
          </slot>

          <div class="modal-body bg-light">
            <slot name="body">
              default body
            </slot>
          </div>

          <div v-if="hasFooter" class="modal-footer bg-light">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  computed: {
    hasFooter() {
      console.log(this.$slots)
      return this.$slots['footer'];
    }
  }
}
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  padding-left: 20px;
  padding-right: 20px;
}

.modal-container {
  min-width: 300px;
  max-width: 900px;
  margin: 0px auto;
  box-shadow: 0 8px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  border-top: 1px solid #888;
}

.modal-body {
  max-height: 350px;
  overflow: auto;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


